module.exports = __webpack_public_path__ + "static/img/pc22.5ba89d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc22.png
// module id = aY6+
// module chunks = 73